
var app = angular.module('directives.counters', []);

require('./directives/counters.js');
require('./stylesheets/counters.scss');
require('./templates/index.html');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/counters/index.js
 ** module id = 154
 ** module chunks = 1
 **/